import React, { useEffect, useState, useRef } from "react";
import light from "../../Assests/Light.svg";
import skip from "../../Assests/X.svg";
import { getRecommendations, skipUser } from "../../Services/ShowsApi";
import profileIcon from "../../Assests/profile.png";
import insta from "../../Assests/Insta.svg";
import facebook from "../../Assests/Facebook.svg";
import spotify from "../../Assests/Spotify.svg";
import linkedin from "../../Assests/Linkedin.svg";
import youtube from "../../Assests/Youtube.svg";
import DollarCoin from "../../Assests/Dollar Coins.svg";
import { updateConnects } from "../../Services/ShowsApi";
import { API_STATUS } from '../../utils/constant'
import { useLoader } from "../../Components/LoaderContext";
import { Tooltip } from "@mui/material";
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { useSelector } from 'react-redux';
import { inviteGuest } from "../../Services/SchedulesApi";
import PropTypes from 'prop-types';
import { getOldRecommendations } from "../../Data/dataStore";
import { fontWeight } from "@mui/system";
import "./Recommendations.css";
import { capitalizeNames } from "../../utils/nameUtils";



const styles = {
  container: {
    width: "100%",
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    display: "inline-flex",
  },
  cardContainer: {
    flex: "1 1 0",
    height:"100%",
    position: "relative",
  },
  card: {
    position: "absolute",
    padding: "1.6vh",
    background: "rgba(255, 255, 255, 0.08)",
    borderRadius: "1.6vh",
    outline: "1px rgba(175.31, 175.31, 175.31, 0.50) solid",
    outlineOffset: "-1px",
    backdropFilter: "blur(1.2vh)",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1.2vh",
    display: "inline-flex",
    height:"100%",
  },
  cardScrollable: {
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255,255,255,0.3) transparent",
    height: "100%",
    justifyContent: "flex-start",
  },
  image: {
    // alignSelf: "stretch",
    flex: "1 1 0",
    borderRadius: "0.8vh",
    width: "-webkit-fill-available",
    objectFit: "cover",
    height: "0",
  },
  icon: {
    flex: "1 1 0",
    borderRadius: "0.8vh",
    maxWidth: "-webkit-fill-available",
    objectFit: "cover",
    height: "0",
  },
  textContainer: {
    alignSelf: "stretch",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "0.8vh",
    display: "flex",
  },
  nameContainer: {
    alignSelf: "stretch",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.8vh",
    // display: "inline-flex",
  },
  name: {
    flex: "1 1 0",
    color: "white",
    fontSize: "2.2vh",
    fontWeight: "bolder",
    letterSpacing: "0.16vh",
    wordWrap: "break-word",
  },
  role: {
    flex: "1 1 0",
    textAlign: "right",
    color: "white",
    fontSize: "1.4vh",
    fontWeight: "bolder",
    letterSpacing: "0.28vh",
    wordWrap: "break-word",
  },
  statusContainer: {
    alignSelf: "stretch",
    justifyContent: "space-between",
    alignItems: "center",
    display: "inline-flex",
  },
  statusIndicator: {
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.8vh",
    display: "flex",
  },
  statusText: {
    color: "white",
    fontSize: "1.4vh",
    fontWeight: "bolder",
    letterSpacing: "0.24vh",
    wordWrap: "break-word",
  },
  priceContainer: {
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.8vh",
    display: "flex",
  },
  priceContainerImg: {
    width: "1.8vh",
    height: "1.8vh"
  },
  priceContainerValue: {
    display: "flex",
    alignItems: "center",
    gap: "0.2vh"
  },
  priceText: {
    color: "white",
    fontSize: "1.4vh",
    fontWeight: "bolder",
    letterSpacing: "0.28vh",
    wordWrap: "break-word",
  },
  buttonContainer: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "2.4vh",
    display: "inline-flex",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.8vh 1.6vh",
    backgroundColor: "rgba(41, 104, 254, 0.8)", // Default background color
    color: "#fff", // Text color
    border: "none",
    borderRadius: "1.6vh",
    cursor: "pointer",
    fontSize: "1.8vh",
    fontWeight: "bolder",
    transition: "background-color 0.3s ease",
    ":hover": {
      backgroundColor: "#0056b3", // Hover background color
    },
    ":active": {
      backgroundColor: "#004080", // Active (clicked) background color
    },
    gap: "0.8vh",
    width: "100%",
  },
  buttonText: {
    textAlign: "right",
    color: "white",
    fontSize: "1.6vh",
    fontWeight: "bolder",
    letterSpacing: "0.64vh",
    wordWrap: "break-word",
  },
  section: {
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "0.8vh",
    display: "inline-flex",
    height: "100%",
    fontSize: "1.6vh"
  },
  sectionTitle: {
    color: "white",
    fontSize: "1.8vh",
    fontWeight: "bolder",
    letterSpacing: "0.112vh",
    wordWrap: "break-word",
    flexShrink: 0,
  },
  bioContent: {
    width: "100%",
    color: "white",
    alignSelf: "stretch",
    flex: 1,
    position: "relative",
    fontSize: "1.6vh",
    letterSpacing: "0.04vh",
    fontWeight: 200,
    textShadow: "var(--text-shadow-2)",
  },
  bioContentTruncated: {
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    whiteSpace: "normal",
  },
  bioContentExpanded: {
    whiteSpace: "normal",
  },
  readMoreBtn: {
    color: "rgba(41, 104, 254, 0.80)",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "1.2vh",
    padding: 0,
    fontWeight: "600",
  },
  interestsContainer: {
    alignSelf: "stretch",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "1.6vh",
    display: "inline-flex",
    flexWrap: "wrap",
    ...(window.innerHeight <= 650 && { height: "5vh" }),
    overflow: "hidden",  // Prevents content from overflowing
    overflowY: "auto",
    scrollbarWidth: "none",  /* Firefox */
    msOverflowStyle: "none",
  },
  pill: {
    paddingLeft: "1vh",
    paddingRight: "1vh",
    paddingTop: "0.5vh",
    paddingBottom: "0.5vh",
    background: "rgba(255, 255, 255, 0.80)",
    borderRadius: "3vh",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.5vh",
    display: "flex",
  },
  pillText: {
    textAlign: "right",
    justifyContent: "flex-end",
    display: "flex",
    flexDirection: "column",
    color: "#000029",
    fontSize: "1.4vh",
    fontWeight: "bolder",
    letterSpacing: "0.24vh",
    wordWrap: "break-word",
  },
  socialIconsContainer: {
    alignSelf: "stretch",
    height: "5vh",
    justifyContent: "space-between",
    alignItems: "center",
    display: "inline-flex",
  },
  socialLink: {
    width: "5vh",
    height: "5vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.5vh"
  },
  skipButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.8vh 1.6vh',
    backgroundColor: 'rgba(255, 166, 0, 0)',
    color: 'rgb(255, 255, 255)',
    border: '1px solid rgb(255, 255, 255)',
    borderRadius: '1.6vh',
    cursor: 'pointer',
    fontSize: '1.8vh',
    fontWeight: 'bold',
    transition: '0.3s',
    gap: '0.8vh',
    width: '100%'
  },
  connectIcon: {
    width: '2.4vh',
    height: '2.4vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  connectText: {
    fontSize: '1.8vh',
    fontWeight: 'bolder',
    letterSpacing: '0.064vh',
  }
};

// Reusable Components
const StatusIndicator = ({ Collaborate }) => (
  <div style={styles.statusIndicator}>
    <div className={Collaborate ? "recommentation_collab_status" : "recommentation_collab_status_false"} />
    <div style={styles.statusText}>{
      Collaborate ? "Open to Collaboration" : "Closed to Collaboration"}</div>
  </div>
);

const PriceIndicator = ({ Rate }) => (
  <div style={styles.priceContainer}>
    <img style={styles.priceContainerImg} src={DollarCoin} />
    <div style={styles.priceContainerValue}>
      <span style={{ ...styles.priceText, fontSize: "1.6vh" }}>$</span>
      <span style={styles.priceText}>{Rate || "-"}</span>
      <span style={styles.priceText}>/Ep</span>
    </div>
  </div>
);

const Button = ({ text, onClick, src }) => (
  <button 
    className="recommendation-card-button"
    style={text === 'Skip' ? styles.skipButton : styles.button} 
    onClick={onClick}
  >
    <div style={styles.connectText}>{text}</div>
    <div style={styles.connectIcon}>
      <img src={src} alt="Light" style={{ width: "100%", height: "100%" }} />
    </div>
  </button>
);

const Card = ({
  FirstName,
  LastName,
  role,
  Collaborate,
  Rate,
  ProfileImageKey,
  style,
  onSkip,
  handleClickConnect,
  UserID,
}) => (
  <div className="recommendation-card" style={{ ...styles.card, ...style }}>
    <img
      style={ProfileImageKey ? styles.image : styles.icon}
      src={ProfileImageKey ? ProfileImageKey : profileIcon}
      alt={FirstName}
    />
    <div style={styles.textContainer}>
      <div style={styles.nameContainer}>
        <div style={styles.name} className="ellipsis">
          {capitalizeNames(FirstName, LastName).fullName}
        </div>
        <div style={styles.role}>{role}</div>
      </div>
      <div style={styles.statusContainer}>
        <StatusIndicator Collaborate={Collaborate} />
        <PriceIndicator price={Rate} />
      </div>
    </div>
    <div style={styles.buttonContainer}>
      <Button text="Skip" src={skip} onClick={onSkip} />
      <Button
        text="Connect"
        src={light}
        onClick={() => handleClickConnect(UserID)}
      />
    </div>

    <div className="recommendation-card-content">
      <div className="recommendation-card-left">
        <img
          className={ProfileImageKey ? "recommendation-card-image" : "recommendation-card-icon"}
          src={ProfileImageKey ? ProfileImageKey : profileIcon}
          alt={FirstName}
        />
        <div className="recommendation-card-text-container">
          <div style={styles.nameContainer}>
            <div className="recommendation-card-name ellipsis" style={styles.name}>
              {capitalizeNames(FirstName, LastName).fullName}
            </div>
            <div className="recommendation-card-role" style={styles.role}>{role}</div>
          </div>
          <div className="recommendation-card-status-container" style={styles.statusContainer}>
            <StatusIndicator Collaborate={Collaborate} />
            <PriceIndicator price={Rate} />
          </div>
        </div>
      </div>
      
      <div className="recommendation-card-right">
        <div className="recommendation-card-button-container">
          <Button text="Skip" src={skip} onClick={onSkip} />
          <Button
            text="Connect"
            src={light}
            onClick={() => handleClickConnect(UserID)}
          />
        </div>
      </div>
    </div>
  </div>
);

const GlassPanelComponent = ({
  bioTitle = "Bio",
  bioContent = "This user has not shared their bio yet!",
  interestsTitle = "Interests",
  connectTitle = "Connect On",
  Bio,
  FacebookLink,
  SpotifyLink,
  InstagramLink,
  LinkedinLink,
  YoutubeLink,
  Topics,
  style,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsReadMore, setNeedsReadMore] = useState(false);
  const [lineClamp, setLineClamp] = useState(2);
  const bioRef = useRef(null);
  const bioText = Bio || bioContent;

  useEffect(() => {
    const updateLineClamp = () => {
      const aspectRatio = window.innerWidth / window.innerHeight;
      if (aspectRatio > 2.3) {
        setLineClamp(1);
      } else if (window.innerWidth === 1512 && window.innerHeight === 982) {
        setLineClamp(5);
      } else if (window.innerWidth === 3024 && window.innerHeight === 1964) {
        setLineClamp(5);
      } else {
        setLineClamp(3);
      }
    };

    updateLineClamp();
    window.addEventListener('resize', updateLineClamp);
    return () => window.removeEventListener('resize', updateLineClamp);
  }, []);

  useEffect(() => {
    const checkOverflow = () => {
      if (bioRef.current && !isExpanded) {
        const element = bioRef.current;
        const isTextOverflowing = element.scrollHeight > element.clientHeight;
        setNeedsReadMore(isTextOverflowing);
      }
    };

    if (!isExpanded) {
      checkOverflow();
      const timeoutId = setTimeout(checkOverflow, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [bioText, isExpanded, lineClamp]);

  return (
    <div style={{ ...styles.card, ...(isExpanded ? styles.cardScrollable : {}), ...style }}>
      <Section title={bioTitle} style={{ height: "100%" }}>
        <div>
          <div 
            ref={bioRef}
            style={{
              ...styles.bioContent,
              ...(isExpanded ? styles.bioContentExpanded : styles.bioContentTruncated),
              ...(!isExpanded && {
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: lineClamp,
                WebkitBoxOrient: "vertical",
                whiteSpace: "normal",
              })
            }}
          >
            {bioText}
          </div>
          {(needsReadMore || isExpanded) && (
            <button 
              style={styles.readMoreBtn}
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? 'Read Less...' : 'Read More...'}
            </button>
          )}
        </div>
      </Section>

      <Section title={interestsTitle} style={{ height: "100%" }}>
        <div style={styles.interestsContainer}>
          {Topics && Topics.length > 0 ? (
            <>
              {window.innerHeight <= 650 ? (
                <>
                  {Topics.slice(0, 2).map((interest, index) => (
                    <Pill key={index} text={interest} />
                  ))}
                  {Topics.length > 2 && (
                    <Pill text={`+${Topics.length - 2}`} />
                  )}
                </>
              ) : (
                Topics.map((interest, index) => (
                  <Pill key={index} text={interest} />
                ))
              )}
            </>
          ) : (
            <span>User hasn't added any interested topics yet!</span>
          )}
        </div>
      </Section>


      {/* Connect Section */}
      <Section title={connectTitle}>
        <div style={styles.socialIconsContainer}>
          {[
            { icon: facebook, link: FacebookLink, alt: "Facebook" },
            { icon: spotify, link: SpotifyLink, alt: "Spotify" },
            { icon: insta, link: InstagramLink, alt: "Instagram" },
            { icon: linkedin, link: LinkedinLink, alt: "LinkedIn" },
            { icon: youtube, link: YoutubeLink, alt: "YouTube" },
          ].map((social, index) => (
            <SocialIcon
              key={index}
              icon={social.icon}
              link={social.link}
              alt={social.alt}
            />
          ))}
        </div>
      </Section>
    </div>
  );
};

GlassPanelComponent.propTypes = {
  bioContent: PropTypes.string,
};

// Reusable Section Component
const Section = ({ title, children, style }) => (
  <div style={{ ...styles.section, ...style }}>
    <div style={styles.sectionTitle}>{title}</div>
    {children}
  </div>
);

// Reusable Pill Component for Interests
const Pill = ({ text }) => (
  <div style={styles.pill}>
    {!text.startsWith('+') && <div style={styles.pillText}>#</div>}
    <div style={styles.pillText}>{text}</div>
  </div>
);

// Reusable Social Icon Component
const SocialIcon = ({ icon, link, alt }) => {
  const normalizedLink = normalizeLink(link);
  const isLinked = normalizedLink !== null;

  const handleKeyDown = (e) => {
    if (!isLinked && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
    }
  };

  return (
    <a
      href={isLinked ? normalizedLink : undefined}
      target={isLinked ? "_blank" : undefined}
      rel={isLinked ? "noopener noreferrer" : undefined}
      style={styles.socialLink}
      onClick={(e) => {
        if (!isLinked) {
          e.preventDefault();
        }
      }}
      {...(!isLinked && {
        role: "button",
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        "aria-disabled": true
      })}
    >
      <Tooltip
        title={!isLinked ? `${alt}'s account not linked!` : `Click to open ${alt}'s profile.`}
        arrow
        placement="top"
      >
        <img
          className={isLinked ? "socialIcon_linked" : "socialIcon_unlinked"}
          src={icon}
          alt={alt}
        />
      </Tooltip>
    </a>
  );
};

const normalizeLink = (url) => {
  if (!url) return null;
  return url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
};


// Email InvitePopup subcomponent
const EmailInvitePopup = ({
  show, onClose, guestEmail, setGuestEmail, guestNote, setGuestNote, inviteLoading, inviteSuccess, handleSendInvite, emailFocused, setEmailFocused, noteFocused, setNoteFocused,
  emailError, noteError
}) => {
  if (!show) return null;
  return (
    <div
      className="invite-popup-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.55)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <dialog
        className="invite-popup-card"
        open
        onClick={e => e.stopPropagation()}
        onKeyDown={e => { if (e.key === 'Escape') onClose(); }}
        onClose={onClose}
        role="dialog"
        aria-modal="true"
        style={{
          background: '#000029',
          border: 'none',
          outline: 'none',
          borderRadius: "2.4vh",
          boxShadow: '0 0.8vh 3.2vh rgba(0,0,0,0.25)',
          padding: '5.6vh 4.8vh 4.8vh 4.8vh',
          minWidth: "48vh",
          maxWidth: "60vh",
          minHeight: "42vh",
          width: '95vw',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <button
          style={{
            position: 'absolute',
            top: "1.8vh",
            right: "1.8vh",
            background: 'none',
            border: 'none',
            color: '#fff',
            fontSize: "2.8vh",
            cursor: 'pointer',
            borderRadius: '50%',
            width: "3.8vh",
            height: "3.8vh",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.2s',
          }}
          onClick={onClose}
          aria-label="Close"
          onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
          onFocus={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
          onMouseOut={e => e.currentTarget.style.background = 'none'}
          onBlur={e => e.currentTarget.style.background = 'none'}
        >
          <span style={{fontWeight: 700, fontSize: "3.2vh", lineHeight: 1}}>×</span>
        </button>
        <h2 style={{ color: '#fff', fontWeight: 700, marginBottom: "0.6vh", marginTop: 0, fontSize: "2.6vh", letterSpacing: 0.5 }}>Invite a Guest</h2>
        <p style={{ color: '#bdbdbd', fontSize: "1.5vh", marginBottom: "2.8vh", textAlign: 'center', marginTop: 0 }}>
          Invite someone to join the platform by email.
        </p>
        <div style={{ height: "1.0vh" }} />
        <div style={{ position: 'relative', width: '100%', marginBottom: "2.4vh" }}>
          <input
            type="email"
            id="invite-guest-email"
            style={{
              width: '100%',
              padding: '1.8vh 1.4vh 1.8vh 1.8vh',
              borderRadius: "1.4vh",
              border: emailFocused ? '2px solid rgb(27, 96, 161)' : '1.5px solid #444',
              background: 'rgba(255,255,255,0.07)',
              color: 'white',
              fontSize: "1.6vh",
              outline: 'none',
              boxSizing: 'border-box',
              transition: 'border 0.2s',
            }}
            value={guestEmail}
            onChange={e => setGuestEmail(e.target.value)}
            onFocus={() => setEmailFocused(true)}
            onBlur={() => setEmailFocused(false)}
            autoComplete="off"
            required
          />
          <label
            htmlFor="invite-guest-email"
            style={{
              position: 'absolute',
              left: "1.6vh",
              top: (emailFocused || guestEmail) ? "0.6vh" : "1.8vh",
              fontSize: (emailFocused || guestEmail) ? "1.2vh" : "1.6vh",
              color: (emailFocused || guestEmail) ? '#bdbdbd' : '#fff',
              pointerEvents: 'none',
              transition: 'all 0.2s',
              background: 'transparent',
              padding: (emailFocused || guestEmail) ? '0vh 0.4vh' : '0vh',
            }}
          >
            Guest Email
          </label>
          {emailError && (
            <div style={{ color: 'red', fontSize: "1.3vh", marginTop: "0.4vh" }}>{emailError}</div>
          )}
        </div>
        <div style={{ position: 'relative', width: '100%', marginBottom: "2.4vh" }}>
          <textarea
            id="invite-guest-note"
            style={{
              width: '100%',
              padding: '1.8vh 1.4vh 1.8vh 1.8vh',
              borderRadius: "1.4vh",
              border: noteFocused ? '2px solid #0985FB' : '1.5px solid #444',
              background: 'rgba(255,255,255,0.07)',
              color: 'white',
              fontSize: "1.6vh",
              minHeight: "8.0vh",
              resize: 'vertical',
              outline: 'none',
              boxSizing: 'border-box',
              transition: 'border 0.2s',
            }}
            value={guestNote}
            onChange={e => setGuestNote(e.target.value)}
            onFocus={() => setNoteFocused(true)}
            onBlur={() => setNoteFocused(false)}
            required
          />
          <label
            htmlFor="invite-guest-note"
            style={{
              position: 'absolute',
              left: "1.6vh",
              top: (noteFocused || guestNote) ? "0.6vh" : "1.8vh",
              fontSize: (noteFocused || guestNote) ? "1.2vh" : "1.6vh",
              color: (noteFocused || guestNote) ? '#bdbdbd' : '#fff',
              pointerEvents: 'none',
              transition: 'all 0.2s',
              background: 'transparent',
              padding: (noteFocused || guestNote) ? '0vh 0.4vh' : '0vh',
            }}
          >
            Enter a note for your guest
          </label>
          {noteError && (
            <div style={{ color: 'red', fontSize: "1.3vh", marginTop: "0.4vh" }}>{noteError}</div>
          )}
        </div>
        <button
          style={{
            background: 'linear-gradient(90deg, #0985FB 0%, #472DDB 100%)',
            borderRadius: "1.2vh",
            fontSize: "1.6vh",
            fontWeight: 700,
            minHeight: "4.4vh",
            color: '#fff',
            border: 'none',
            width: '100%',
            marginTop: "0.8vh",
            marginBottom: "0.6vh",
            opacity: inviteLoading ? 0.7 : 1,
            cursor: inviteLoading ? 'not-allowed' : 'pointer',
            boxShadow: '0 0.2vh 0.8vh rgba(9,133,251,0.08)',
            transition: 'background 0.2s',
          }}
          onClick={handleSendInvite}
          disabled={inviteLoading}
        >
          {inviteLoading ? 'Sending...' : 'Send Invitation'}
        </button>
        {inviteSuccess === "success" && (
          <div style={{ color: '#4caf50', textAlign: 'center', fontWeight: 'bold', fontSize: "1.6vh", marginTop: "1.0vh" }}>
            Invite sent successfully!
          </div>
        )}
        {inviteSuccess === "exists" && (
          <div style={{ color: 'red', textAlign: 'center', fontWeight: 'bold', fontSize: "1.6vh", marginTop: "1.0vh" }}>
            This email is already associated with an existing user.
          </div>
        )}
      </dialog>
    </div>
  );
};



EmailInvitePopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  guestEmail: PropTypes.string.isRequired,
  setGuestEmail: PropTypes.func.isRequired,
  guestNote: PropTypes.string.isRequired,
  setGuestNote: PropTypes.func.isRequired,
  inviteLoading: PropTypes.bool.isRequired,
  inviteSuccess: PropTypes.string.isRequired,
  handleSendInvite: PropTypes.func.isRequired,
  emailFocused: PropTypes.bool.isRequired,
  setEmailFocused: PropTypes.func.isRequired,
  noteFocused: PropTypes.bool.isRequired,
  setNoteFocused: PropTypes.func.isRequired,
  emailError: PropTypes.string,
  noteError: PropTypes.string,
};



// DoneWithRecommendations subcomponent
const DoneWithRecommendations = ({ reiterateRecommendations, handleEmailInviteClick }) => (
  <div style={{
    width: '100%',
    minHeight: '100%',
    alignItems: 'center',
    justifyItems: 'center',
    borderRadius: '2.4vh',
    background: '#14143a',
    gap: '1.6vh',
    justifyContent: 'center',
    display: 'flex',
    alignContent: 'space-around',
    flexWrap: 'wrap',
    flexDirection: 'column',
    marginLeft: "4.0vh",
  }}>
    <div>
      <h2 style={{fontSize: "2.4vh"}}>Done with recommendations.</h2>
    </div>
    <p style={{fontSize: "1.4vh"}}>Do you want to start again?</p>
    <div>
      <button onClick={reiterateRecommendations} style={styles.button}>
        Start Again
        <div style={styles.connectIcon}>
          <RefreshRoundedIcon style={{width:"100%",height:"100%"}}/>
        </div>
      </button>
    </div>
    <p style={{fontSize: "1.4vh"}}>Don't see creators you want to connect? Send them an invite.</p>
    <div style={{ display: 'flex', gap: '1.6vh', width: '100%', maxWidth: '40vh' }}>
      <button onClick={handleEmailInviteClick} style={{...styles.button, minWidth: '14vh', flex: '1 1 auto',     backgroundColor: 'transparent', border: '0.1vh solid #fff'}}>
        Invite by Email
      </button>
      <button style={{...styles.button, minWidth: '14vh', flex: '1 1 auto'}}>
        Share on Social
      </button>
    </div>
  </div>
);


DoneWithRecommendations.propTypes = {
  reiterateRecommendations: PropTypes.func.isRequired,
  handleEmailInviteClick: PropTypes.func.isRequired,
};

// Main Component
const Recommendations = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [creators, setCreators] = useState([]);
    const [creators, setCreators] = useState(getOldRecommendations());
  const [page, setPage] = useState(1);
  const [limit] = useState(100);
  const [totalCount, setTotalCount] = useState(0);
  const [globalIndex, setGlobalIndex] = useState(0);
  const [doneWithAll, setDoneWithAll] = useState(false);

  const [showEmailInvitePopup, setShowEmailInvitePopup] = useState(false);
  const [guestEmail, setGuestEmail] = useState("");
  const [guestNote, setGuestNote] = useState("");
  const [inviteLoading, setInviteLoading] = useState(false);
  const [inviteSuccess, setInviteSuccess] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);
  const [noteFocused, setNoteFocused] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [noteError, setNoteError] = useState("");


  const { triggerLoader, hideLoader } = useLoader();
  const userData = useSelector((state) => state.user);

  const fetchData = async (pg) => {
    try {
      const response = await getRecommendations(pg, limit);
      const data = response?.data?.body?.Data || [];
      const total = response?.data?.body?.totalCount || 0;

      if (data.length > 0) {
        setCreators(data);
        setCurrentIndex(0);
        setPage(pg);
        setTotalCount(total);
      } else {
        setDoneWithAll(true);
      }
    } catch (error) {
      console.error("Error fetching top creators:", error);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  const handleSkip = async (id) => {
    const data = {
      UserID: localStorage.getItem("user_id"),
      SkippedUserID: id
    };
    await skipUser(data);

    const nextIndex = currentIndex + 1;
    const nextGlobalIndex = globalIndex + 1;

    if (nextGlobalIndex >= totalCount) {
      setDoneWithAll(true);
    } else if (nextIndex < creators.length) {
      setCurrentIndex(nextIndex);
      setGlobalIndex(nextGlobalIndex);
    } else {
      setGlobalIndex(nextGlobalIndex);
      fetchData(page + 1);
    }
  };

  const handleClickConnect = async (id) => {
    triggerLoader("Sending connection request...");
    const data = {
      SenderID: localStorage.getItem("user_id"),
      ReceiverID: id,
    };

    let res = await updateConnects(data);
    if (res?.status == API_STATUS.success) {
      hideLoader();
      handleSkip(id);
    }
  };

  const reiterateRecommendations = () => {
    setDoneWithAll(false);
    setCurrentIndex(0);
    setGlobalIndex(0);
    setPage(1);
    fetchData(1);
  };

  const handleEmailInviteClick = () => {
    setShowEmailInvitePopup(true);
    setGuestEmail("");
    setGuestNote("");
    setInviteSuccess(false);
  };
  const handleCloseEmailInvitePopup = () => {
    setShowEmailInvitePopup(false);
    setInviteSuccess(false);
  };
  const handleSendInvite = async () => {
    let hasError = false;
    if (!guestEmail) {
      setEmailError("Please fill the required field");
      hasError = true;
    } else {
      setEmailError("");
    }
    if (!guestNote) {
      setNoteError("Please fill the required field");
      hasError = true;
    } else {
      setNoteError("");
    }
    if (hasError) return;
    setInviteLoading(true);
    try {
      const data = {
        guestEmail: guestEmail,
        guestNote: guestNote,
        senderFirstName: userData?.FirstName || '',
        senderLastName: userData?.LastName || ''
      };

      const response = await inviteGuest(data);

      let messageObj = response && typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data || response;

      if (messageObj && messageObj.message === "User already exists.") {
        setInviteSuccess("exists");
        setTimeout(() => {
          setInviteSuccess(false);
          setShowEmailInvitePopup(false);
          setGuestEmail('');
          setGuestNote('');
        }, 2500);
      } else if (messageObj && messageObj.message === "Email sent successfully.") {
        setInviteSuccess("success");
        setTimeout(() => {
          setShowEmailInvitePopup(false);
          setGuestEmail('');
          setGuestNote('');
          setInviteSuccess(false);
        }, 1500);
      } else {
        console.error('Failed to send invite:', response);
      }
    } catch (error) {
      console.error('Error sending invite:', error);
    } finally {
      setInviteLoading(false);
    }
  };

  const visibleCreators = [
    creators[(currentIndex + 2) % creators.length],
    creators[(currentIndex + 1) % creators.length],
    creators[(currentIndex + 0) % creators.length],
  ].filter(Boolean);

  if (doneWithAll) {
    return (
      <>
        <DoneWithRecommendations
          reiterateRecommendations={reiterateRecommendations}
          handleEmailInviteClick={handleEmailInviteClick}
        />
        <EmailInvitePopup
          show={showEmailInvitePopup}
          onClose={handleCloseEmailInvitePopup}
          guestEmail={guestEmail}
          setGuestEmail={setGuestEmail}
          guestNote={guestNote}
          setGuestNote={setGuestNote}
          inviteLoading={inviteLoading}
          inviteSuccess={inviteSuccess}
          handleSendInvite={handleSendInvite}
          emailFocused={emailFocused}
          setEmailFocused={setEmailFocused}
          noteFocused={noteFocused}
          setNoteFocused={setNoteFocused}
          emailError={emailError}
          noteError={noteError}
        />
      </>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "1.6vh",
        display: "inline-flex",
        top: "9vh",
      }}
    >
      <div
        style={{
          alignSelf: "stretch",
          justifyContent: "space-between",
          alignItems: "center",
          display: "inline-flex",
        }}
      >
        <div
          style={{
            color: "white",
            fontSize: "1.8vh",
            fontWeight: "bolder",
            letterSpacing: "0.144vh",
            wordWrap: "break-word",
            // marginLeft: 40,
          }}
        >
          Recommendations
        </div>
      </div>
      <div style={styles.container}>
        <div style={styles.cardContainer}>
          {visibleCreators.map((creator, index) => (
            <Card
              key={index}
              {...creator}
              style={{
                width: '22vw',
                // height: 380 + index * 16,
                // height:"100%",
                left: `${index * 5.2}vh`,
                // top: index * 8,
                opacity: index === 0 ? 0.2 : index === 1 ? 0.4 : 1,
                filter: index < 2 ? "blur(0.4vh)" : "none",
              }}
              onSkip={() => handleSkip(creator?.UserID)}
              handleClickConnect={() => handleClickConnect(creator?.UserID)}
            />
          ))}
        </div>
        <div style={styles.cardContainer}>
          {visibleCreators.map((creator, index) => (
            <GlassPanelComponent
              key={index}
              {...creator}
              style={{
                width: '27vw',
                // height: 380 + index * 16,
                left: `${index * 1.2}vh`,
                // top: index * 8,
                opacity: index === 0 ? 0.2 : index === 1 ? 0.4 : 1,
                filter: index < 2 ? "blur(0.4vh)" : "none",
              }}
              onSkip={() => handleSkip(creator?.UserID)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Recommendations;
